import {
  createResetableStore,
  preventMultipleActionDispatch,
} from "~/utils/store";

export default createResetableStore({
  namespaced: true,
  state() {
    return {
      userProfileData: null,
    };
  },
  getters: {
    isOperator(state) {
      return state.userProfileData?.roles.includes("CSR_OPERATOR_RETAIL");
    },
  },
  mutations: {
    setUserProfileData(state, userProfileData) {
      state.userProfileData = userProfileData;
    },
  },
  actions: {
    fetchData: preventMultipleActionDispatch(async function (
      { commit },
      { dataloader }
    ) {
      commit("setUserProfileData", await dataloader.getUserProfile());
    }),
  },
});
